import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';
import { listWorkflowDetailsQuery } from '@services/gql.service';
import {
  QuarterCloseChecklistRowSections,
  QuarterCloseChecklistRowTitles,
} from '../../../quarter-close-checklist/models/quarter-close-checklist.model';

export interface WorkflowProperty {
  route: string;
  locked: boolean;
  month: string;
  assigned_by: string;
  assigned_to: string;
  assigned_date: string;
  last_update_info?: {
    update_date: string | null;
    updated_by: string | null;
    ts: string;
  };
}

export interface Workflow extends Omit<listWorkflowDetailsQuery, 'properties'> {
  properties: WorkflowProperty;
  updatedAuthorFullName: string;
  last_updated_by_full_name: string;
  last_updated_by: string;
  last_update_date: string;
  workflowName: QuarterCloseChecklistRowTitles;
  section: QuarterCloseChecklistRowSections;
}

export interface WorkflowState extends EntityState<Workflow> {}

export type WorkflowModel = getEntityType<WorkflowState>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'workflow' })
export class WorkflowStore extends EntityStore<WorkflowState> {
  constructor() {
    super({});
  }
}
